import * as yup from 'yup';

var getAddNewGroupSchema = function getAddNewGroupSchema(error) {
  return yup.object().shape({
    groupName: yup.string().required('').test('groupName', '', function (value, ctx) {
      if (error) {
        return ctx.createError({
          message: error
        });
      }

      return true;
    }),
    users: yup.array().min(1, ' '),
    permissions: yup.array().min(1, ' ')
  });
};

export { getAddNewGroupSchema };